import React from "react";

import { Breadcrumbs as PyBreadcrumbs, Text } from "@performyard/py-components";

import Breadcrumbs from "../../../../components/Breadcrumbs";

import { useIsNewNavigation } from "../../../../api/hooks/defs/navigation";

import { MEETING_BREADCRUMB_SOURCE, useMeetingBreadcrumbSource } from "../../utils/breadcrumbSource";

import { config } from "../config";

type MeetingsTableBreadcrumbsProps = {
	workspaceName: string;
	workspaceId: string;
	previousSearchParams?: string;
	isAdminNonParticipant?: boolean;
};

const MeetingsTableBreadcrumbs = ({
	workspaceName,
	workspaceId,
	previousSearchParams = "",
	isAdminNonParticipant = false,
}: MeetingsTableBreadcrumbsProps): React.ReactElement => {
	const isNewNav = useIsNewNavigation();
	const source = useMeetingBreadcrumbSource();
	const parentHref = previousSearchParams ? `/meeting-workspaces${previousSearchParams}` : "/meeting-workspaces";
	const workspaceHref = `/meeting-workspaces/${workspaceId}`;

	if (isNewNav) {
		const rootItem =
			source === MEETING_BREADCRUMB_SOURCE.companyMeetings
				? {
						pageId: "meetingWorkspaces",
						name: "Company Meetings",
						href: "/company/meetings?name=meetingDate&direction=desc",
					}
				: source === MEETING_BREADCRUMB_SOURCE.actionItems
					? {
							pageId: "meetingWorkspaces",
							name: "My Action Items",
							href: "/meeting-workspaces/?tab=action-items",
						}
					: { pageId: "meetingWorkspaces", name: "My Meeting Workspaces", href: parentHref };

		return (
			<PyBreadcrumbs
				items={[rootItem, { pageId: "workspaceDetails", name: workspaceName, href: workspaceHref }]}
			/>
		);
	}

	return (
		<Breadcrumbs
			pages={[
				{
					pageID: "meetingWorkspaces",
					label: isAdminNonParticipant ? "Meetings" : "Meeting Workspaces",
					url: isAdminNonParticipant ? "/company/meetings" : parentHref,
				},
				{
					pageID: "workspaceDetails",
					label: (
						<div className="py-text-truncate" style={{ maxWidth: config.layout.breadcrumbMaxWidth }}>
							<Text size="paragraph-2" weight="regular" overrideElement="span" wrap={false}>
								{workspaceName}
							</Text>
						</div>
					),
					url: workspaceHref,
				},
			]}
		/>
	);
};

export default MeetingsTableBreadcrumbs;
